import { Snackbar, SnackbarAction } from "@rmwc/snackbar";
import { urlToObject } from "@arcgis/core/core/urlUtils";
import React, { useContext, useEffect, useState } from "react";
import { EmailIcon, EmailShareButton } from "react-share";
import FacebookIcon from "react-share/lib/FacebookIcon";
import FacebookShareButton from "react-share/lib/FacebookShareButton";
import TwitterIcon from "react-share/lib/TwitterIcon";
import TwitterShareButton from "react-share/lib/TwitterShareButton";
import { ApplicationName, assessorInfo, operationalLayerUrl } from "../appConfig";
import { AppContext } from "../contexts/App";
import {Bitly} from "bitly";
const BitlyClient = Bitly;
const bitly = new BitlyClient('a4287f5102147b2edfd5811383389e248a5d1e5a');

const ShareMUGIS = () => {
  const { state, setState } = useContext(AppContext);
  let shareUrl: string = encodeURI(window.location.toString());
  shareUrl = shareUrl.replace("localhost", "127.0.0.1"); //for DEV
  const [currentShareLongUrl, setCurrentShareLongUrl] = useState(shareUrl);
  const [currentShareBitlyUrl, setCurrentShareBitlyUrl] = useState(currentShareLongUrl);

  

  const domparser = new DOMParser();
  /* const encode = (str: string) => {
    var buf = [];

    for (var i = str.length - 1; i >= 0; i--) {
      buf.unshift(["&#", str[i].charCodeAt(), ";"].join(""));
    }

    return buf.join("");
  }; */
  const decode = (str: string) => {
    let doc = domparser.parseFromString(str, "text/html");
    return doc.childNodes[0].innerText;
  };

  const createUrl = () => {
    //alert("Hello from facebook")
    let mapExtent: string = "";
    let selectedQuickMap: string = "";
    let currentBaseMap: string = "";
    let selectedItem: string = "";
    let visibleLayers: any[] = [];
    let opUrl = operationalLayerUrl;
    let url = encodeURI(window.location.toString());
    url = url.replace("localhost", "127.0.0.1"); //for DEV
    if (state.searchResultDetailsItems && state.searchResultDetailsItems.length > 0 && state.searchResultDetailsItems[0][assessorInfo.GIS_ID] !== undefined) { //ONLY SUPPORT THE OPERATIONAL LAYER
      selectedItem = state.searchResultDetailsItems[0][assessorInfo.GIS_ID];
    }
    if (state.mapView) {
      mapExtent =
        Math.round(state.mapView.extent.xmin).toString() +
        "," +
        Math.round(state.mapView.extent.ymin).toString() +
        "," +
        Math.round(state.mapView.extent.xmax).toString() +
        "," +
        Math.round(state.mapView.extent.ymax).toString();
      currentBaseMap = state.mapView.map.basemap.id;
      selectedQuickMap = state.mapView.selectedQuickMap;
      state.mapView.map.allLayers.forEach((item: any) => {
        if (
          item.title ===
          opUrl
            .split("/")
            [opUrl.split("/").indexOf("MapServer") - 1].replace(/_/g, " ")
        ) {
          visibleLayers = item.allSublayers.map((item: any) => {
            if (item.visible) {
              return item.id;
            }
          });
          visibleLayers = visibleLayers.filter((item: any) => {
            return item !== undefined;
          });
        }
      });
      let urlStr = "";
      if (selectedItem !== "" && selectedItem !== undefined && selectedItem != null) {
        urlStr = url +
        "?selectedItem=" +
        selectedItem +
        "&extent=" +
        mapExtent +
        /* "&qmname=" +
        selectedQuickMap + */
        "&basemapname=" +
        currentBaseMap +
        "&visible=" +
        visibleLayers.toString();
      } else {
        urlStr = url +
        "?extent=" +
        mapExtent +
        /* "&qmname=" +
        selectedQuickMap + */
        "&basemapname=" +
        currentBaseMap +
        "&visible=" +
        visibleLayers.toString();
      }
      return encodeURI(urlStr);
    }
  };

  useEffect(() => {
    if (state.shareMUGIS) {
      let longUrl = createUrl();
      setCurrentShareLongUrl(longUrl);
      const fetchShortlUrl = (async() => {
        const response = await bitly.shorten(longUrl);
        setCurrentShareBitlyUrl(response.link);
        console.log(`Your shortened bitlink is ${response.link}`);
      })
      fetchShortlUrl();
      
    }
    return () => {
      /* if (cleanup) {
          cleanup();
        } */
    };
  }, [state.shareMUGIS]);

  return (
    currentShareLongUrl && (
      <Snackbar
        open={state.shareMUGIS}
        onClose={() => setState({ shareMUGIS: false })}
        message="SHARE"
        timeout={5000}
        dismissIcon={true}
        dismissesOnAction={true}
        action={[
          <FacebookShareButton
            url={currentShareBitlyUrl}
            quote={ApplicationName}
            hashtag="#MunicipalGIS"
            className={"socialMediaButton"}
          >
            <FacebookIcon size={36} />
          </FacebookShareButton>,
          <TwitterShareButton
            url={currentShareBitlyUrl}
            title={ApplicationName}
            className={"socialMediaButton"}
          >
            <TwitterIcon size={36} />
          </TwitterShareButton>,
          <EmailShareButton
            url={currentShareBitlyUrl}
            subject={decode(ApplicationName)}
            body={"Click to see " + decode(ApplicationName)}
            separator=":: "
            className={"socialMediaButton"}
          >
            <EmailIcon size={36} />
          </EmailShareButton>,
        ]}
      />
    )
  );
};

export default ShareMUGIS;
